<ix-modal-header [title]="'Edit Catalog' | translate" [loading]="isFormLoading"></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form [formGroup]="form" class="ix-form-container" (submit)="onSubmit()">
      <ix-fieldset>
        <ix-input
          formControlName="label"
          [label]="'Catalog Name' | translate"
          [required]="true"
          [tooltip]="tooltips.label | translate"
        ></ix-input>
        <ix-select
          formControlName="preferred_trains"
          [label]="'Preferred Trains' | translate"
          [tooltip]="tooltips.preferred_trains | translate"
          [options]="trainOptions$"
          [multiple]="true"
        ></ix-select>
      </ix-fieldset>

      <div class="form-actions">
        <button
          mat-button
          type="submit"
          [disabled]="form.invalid || isFormLoading"
          color="primary"
        >{{ 'Save' | translate }}</button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
